import React from 'react';

import { Block } from '../common/Block.jsx';
import Defaults from '../layout/Defaults.jsx';
import Token from '../common/Token.jsx';

function ErrorMessageComponent(props) {
    const formFieldProps = {};
    if (props.onFormFieldProps) {
        props.onFormFieldProps({ blockConfig: props.blockConfig, type: props.blockType }, formFieldProps);
    }
    let error = formFieldProps.error;
    if (formFieldProps.editor) {
        error = 'This is an example error message.';
    } else if (!error) {
        return null;
    }
    let design;
    const style = {};
    if (props.blockConfig && props.blockConfig.block) {
        Block.mapStyleConfigProps(style, props.blockConfig.block, (propName, propValue) => {
            switch (propName) {
                case 'design':
                    design = propValue;
                    return true;
            }
        })
    }
    if (!design) {
        design = Defaults.Block.ErrorMessage();
    }
    let content = Token.parseTokenizedString(design, () => error);
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit(style, props);
    content = <div className="richText" dangerouslySetInnerHTML={{ __html: content }} style={layoutStyles.style} />
    if (layoutStyles.containerStyle) {
        content = <div style={layoutStyles.containerStyle}>{content}</div>
    }
    return content;
}

export default { Component: ErrorMessageComponent };